// Dutch labels for placeholder keys returned by /api/zzp/contracts/:id/preflight
// and /api/zzp/contracts/bulk-generate. Unknown keys fall through unchanged.

const FIELD_LABELS = {
  Naam: 'Naam medewerker',
  Kvk: 'KvK-nummer',
  Btw_nummer: 'BTW-nummer',
  Bedrijfsnaam: 'Bedrijfsnaam',
  Plaats: 'Plaats medewerker',
  Postcode: 'Postcode medewerker',
  Adres: 'Adres medewerker',
  Datum_in: 'Datum begin',
  Datum_uit: 'Datum eind',
  Tekendatum: 'Tekendatum',
  Bedrag_1: 'Tarief 1',
  Bedrag_2: 'Tarief 2',
  Bedrag_3: 'Tarief 3',
  Bedrag_4: 'Tarief 4',
  Bedrag_5: 'Tarief 5',
  Bedrag_6: 'Tarief 6',
  Bedrag_7: 'Tarief 7',
  Opdrachtgever_naam: 'Opdrachtgever — naam (vul in via tab Opdrachtgevers)',
  Opdrachtgever_plaats: 'Opdrachtgever — plaats (vul in via tab Opdrachtgevers)',
  Opdrachtgever_postcode: 'Opdrachtgever — postcode (vul in via tab Opdrachtgevers)',
  Opdrachtgever_adres: 'Opdrachtgever — adres (vul in via tab Opdrachtgevers)',
  Opdrachtgever_vertegenwoordiger: 'Opdrachtgever — vertegenwoordiger (vul in via tab Opdrachtgevers)',
  Project_naam: 'Projectnaam',
  Werkzaamheden: 'Werkzaamheden',
  Functiegroep: 'Functiegroep van de medewerker',
};

export function fieldLabel(key) {
  return FIELD_LABELS[key] || key;
}
